import { useContext } from 'react';

import { SessionTimeoutContext } from './context';

const useSessionTimeout = () => {
  const context = useContext(SessionTimeoutContext);

  if (context === {}) {
    throw new Error('useSessionTimeout() must be used within SessionTimeoutProvider');
  }

  return context;
};

export default useSessionTimeout;

